/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerControllerDtoEmailCheckRequest model module.
 * @module model/ManagerControllerDtoEmailCheckRequest
 * @version 1.0
 */
class ManagerControllerDtoEmailCheckRequest {
    /**
     * Constructs a new <code>ManagerControllerDtoEmailCheckRequest</code>.
     * @alias module:model/ManagerControllerDtoEmailCheckRequest
     * @param email {String} 
     */
    constructor(email) { 
        
        ManagerControllerDtoEmailCheckRequest.initialize(this, email);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, email) { 
        obj['email'] = email;
    }

    /**
     * Constructs a <code>ManagerControllerDtoEmailCheckRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerControllerDtoEmailCheckRequest} obj Optional instance to populate.
     * @return {module:model/ManagerControllerDtoEmailCheckRequest} The populated <code>ManagerControllerDtoEmailCheckRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerControllerDtoEmailCheckRequest();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerControllerDtoEmailCheckRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerControllerDtoEmailCheckRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ManagerControllerDtoEmailCheckRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}

ManagerControllerDtoEmailCheckRequest.RequiredProperties = ["email"];

/**
 * @member {String} email
 */
ManagerControllerDtoEmailCheckRequest.prototype['email'] = undefined;






export default ManagerControllerDtoEmailCheckRequest;

